export default "__VITE_ASSET__BoWrwOEw__"